import { Link } from 'react-router-dom';

function ManualBreadcrumb({ items }) {
  return (
    <nav className="manual-breadcrumb">
      <Link to="/painel/manual" className="manual-breadcrumb-item">
        <i className="bi bi-house-door"></i>
        Início
      </Link>
      {items.map((item, index) => (
        <span key={index} className="manual-breadcrumb-item">
          <i className="bi bi-chevron-right"></i>
          {item.link ? (
            <Link to={item.link}>{item.label}</Link>
          ) : (
            <span>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

export default ManualBreadcrumb;
